<script lang="ts">
    import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
    import { Button } from '@/components/ui/button';
    import { SvelteMap } from 'svelte/reactivity';
    import { router, useForm } from '@inertiajs/svelte';
    import Modal from '@/components/Modal.svelte';

    type Props = {
        show: boolean;
        entityTitle: string;
        TableComponent: any;
        relatedRecordId: string;
        relationshipName: string; // e.g., 'customers', 'jobs'
        syncRoute: string; // e.g., 'jobs.update'
        currentlyRelated?: any[]; // Currently related records to pre-select
        routeParamName?: string; // e.g., 'job', 'customer' - defaults to 'job'
        recordData?: Record<string, any>; // Current record data to merge with
        reloadUrl?: string;
    };

    let {
        show = $bindable(),
        entityTitle,
        TableComponent,
        relatedRecordId,
        relationshipName,
        syncRoute,
        currentlyRelated = [],
        routeParamName = 'job',
        recordData = {},
        reloadUrl = window.location.href
    }: Props = $props();

    let selectedRecords = $state(new SvelteMap<string, string>());

    // Pre-populate selected records when modal opens
    $effect(() => {
        if (show && currentlyRelated && currentlyRelated.length > 0) {
            selectedRecords.clear();
            currentlyRelated.forEach(record => {
                selectedRecords.set(record.id, record.name || record.title || record.id);
            });
        }
    });

    let form = $state(useForm({
        ...recordData,
        [relationshipName]: []
    }));

    function handleSubmit() {
        const selectedIds = Array.from(selectedRecords.keys());

        // Update the form data with selected IDs
        Object.assign($form, recordData, {
            [relationshipName]: selectedIds
        });

        $form.put(route(syncRoute, { [routeParamName]: relatedRecordId }), {
            onSuccess: () => {
                show = false;
                selectedRecords.clear();
                router.visit(reloadUrl, {
                    only: [routeParamName]
                });
            },
            preserveScroll: true
        });
    }

    function close() {
        show = false;
    }

</script>

{#if show}
    <Modal title="Link Existing {entityTitle}" onClose={close}>
        <div class="mt-4">
            <TableComponent
                view="multi_related"
                bind:selectedCustomers={selectedRecords}
                bind:selectedJobs={selectedRecords}
                onSubmitClick={handleSubmit}
            />
        </div>
    </Modal>
{/if}
